import React from 'react';

const EditIconCollab = function EditIconCollab() {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M4.1875 17.2497H0.75V13.8122L10.8883 3.67383L14.3258 7.11133L4.1875 17.2497ZM10.8909 6.26758L2.58594 14.5726V15.4159H3.42927L11.7343 7.11091L10.8909 6.26758Z" fill="#001760" />
      <path d="M14.8372 1.01617C14.4797 0.658672 13.9022 0.658672 13.5447 1.01617L11.8672 2.69367L15.3047 6.13117L16.9822 4.45367C17.3397 4.09617 17.3397 3.51867 16.9822 3.16117L14.8372 1.01617Z" fill="#001760" />
    </svg>
  );
};
export default EditIconCollab;
